import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { MARICOPA_HOAS } from '../config/hoas';
import './HOAPages.css';

const HOADirectoryPage = () => {
  const [query, setQuery] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.remove('intro-active');
  }, []);

  const results = useMemo(() => {
    const value = query.trim().toLowerCase();
    if (!value) return MARICOPA_HOAS;
    return MARICOPA_HOAS.filter(({ name, aliases = [], manager }) =>
      [name, ...aliases, manager.name].some((text) => text.toLowerCase().includes(value))
    );
  }, [query]);

  return (
    <main className="hoa-page">
      <div className="hoa-shell">
        <Link className="hoa-back" to="/">← Home</Link>
        <header className="hoa-hero hoa-directory-hero">
          <span>Maricopa, Arizona</span>
          <h1>HOA community directory</h1>
          <p>Research management contacts, historical fee estimates, and the questions to answer before buying.</p>
        </header>

        <section className="hoa-directory-intro">
          <div>
            <h2>Start with the community</h2>
            <p>These guides organize the supplied City of Maricopa directory into usable buyer resources. The source PDF is undated, so every fee and management assignment is labeled as a reference—not a quote.</p>
          </div>
          <label className="hoa-search">
            <span>Search communities or managers</span>
            <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Try Province or CCMC" />
          </label>
        </section>

        <section className="hoa-card-grid" aria-live="polite">
          {results.map((item) => (
            <article className="hoa-card" key={item.slug}>
              <div>
                <span className="hoa-card-location">Maricopa, AZ</span>
                <h2>{item.name}</h2>
                {item.aliases?.length > 0 && <p className="hoa-alias">Also known as {item.aliases.join(', ')}</p>}
                <p>{item.overview}</p>
              </div>
              <div className="hoa-card-footer">
                <span>{item.manager.name}</span>
                <Link to={`/maricopa-hoas/${item.slug}`}>View HOA guide →</Link>
              </div>
            </article>
          ))}
          {results.length === 0 && <p className="hoa-empty">No matching HOA was found.</p>}
        </section>
      </div>
    </main>
  );
};

export default HOADirectoryPage;
